import { render, staticRenderFns } from "./AboutSupsis.vue?vue&type=template&id=7de2e030&scoped=true"
import script from "./AboutSupsis.vue?vue&type=script&lang=js"
export * from "./AboutSupsis.vue?vue&type=script&lang=js"
import style0 from "./AboutSupsis.vue?vue&type=style&index=0&id=7de2e030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de2e030",
  null
  
)

export default component.exports